// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"676d9ab6","514":"e4706049","666":"da716bb5","673":"bf58c653","803":"b7552690"}[chunkId] + ".css";
};